export const filterTextablePhones = phone => ['mt', 'wa', 'inttext'].includes(phone.phone_type) && phone.preferred_text
